export default "__VITE_ASSET__MymN_lML__"